(function () {
    'use strict';

    angular
        .module('tracking')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('tracking', {
                url: '/tracking/:day/:crewType',
                params : {
                    day : { squash: true, value: null },
                    crewType : {squash: true, value: null}
                },
                views: {
                    'trackingView': {
                        templateUrl: 'tracking/views/tracking.tpl.html',
                        controller: 'TrackingCtrl',
                        controllerAs: 'tracking'
                    }
                },
                onEnter: function (UserPrivilegesService) {
                   // UserPrivilegesService.setUserPrivilegeView("tracking");
                }
            });
    }
}());
